define([
    'text!./templates/ctrl-group.html',
    'underscore',
    'edge/platform/basler/util/BaslerUtil',
], (templateStr, _, BaslerUtil) => {
    let inputId = 0;

    return () => {
        return {
            require: ['?^form', '?^ngForm'],
            transclude: true,
            scope: {
                callGroup: '@?', //basler json loading indicator
                helpMsg: '@?', //basler info message
                label: '@?',
                readonly: '=?',
                model: '=',
                autofocus: '@?',
                noShowErrors: '=?',
                extraModel: '=?',
                bslClass: '=?',
                customtype: '@?',
                disablePaste: '=?',
                autocomplete: '@?',
                blurRegEx: '@?',
                autoCap: '@?',
            },
            replace: true,
            template: templateStr,

            controller: ['$scope', 'MFPService', ($scope, MFPService) => {

                if (!$scope.model) {
                    throw new Error(`Input with label "${$scope.label}" has an undefined model scope value`);
                }

                $scope.pristine = true;
                //once a different value is set on the model then we mark the field as not pristine
                $scope.$watch('model.value', (newValue, oldValue) => {
                    $scope.pristine = (!$scope.pristine) ? false : newValue === oldValue;
                });

                // Adding extra watch for the extra model
                if ($scope.extraModel) {
                    $scope.pristineExtraModel = true;
                    //once a different value is set on the extra model then we mark the field as not pristine
                    $scope.$watch('extraModel.value', (newValue, oldValue) =>{
                        $scope.pristineExtraModel = (!$scope.pristineExtraModel) ? false : newValue === oldValue;
                    });
                }

                if ($scope.helpMsg) {
                    $scope.callGroupClass = 'after-help-loading-template';
                } else {
                    $scope.callGroupClass = 'no-help-loading-template';
                }

                $scope.handleBlurFormatting = () => {
                    $scope.autoCapitalize();
                    if ($scope.model.value && $scope.blurRegEx) {
                        $scope.model.value = $scope.model.value.replace(new RegExp($scope.blurRegEx, 'g'), '');
                        return $scope.model.value;
                    }
                };

                $scope.autoCapitalize = () => {
                    if ($scope.autoCap && $scope.model.value) {
                        $scope.model.value = MFPService.autoCapitalize($scope.model.value);
                    }
                };
            }],

            link: (scope, element, attrs, ctrls) => {

                scope.mouseEnterAdding = BaslerUtil.mouseEnterAdding;

                scope.mouseLeaveAdding = BaslerUtil.mouseLeaveAdding;

                const parentForm = ctrls[0];
                const validityFn = () => {
                    if (!scope.extraModel) {
                        return scope.model.aspects.valid;
                    }

                    return scope.model.aspects.valid && scope.extraModel.aspects.valid;
                };
                const setPristineFn = () => {
                    //we need to use this postDigest function here because the
                    //watch on 'model.value' in the controller gets called after
                    //this function is called even though the model was changed first
                    scope.$$postDigest(() => {
                            scope.pristine = true;
                            if (scope.extraModel) {
                                scope.pristineExtraModel = true;
                            }
                        });
                };
                if (parentForm) {
                    const removeListenerFn = parentForm.addModelControl(validityFn, setPristineFn);
                    scope.$on('$destroy', removeListenerFn);
                }

                if (!('readonly' in scope) && attrs.readonly === '') {
                    //if readonly attr exists with no value then set it to true
                    scope.readonly = true;
                }
                scope.isVisible = () => {
                    return !('visible' in scope.model.aspects) || scope.model.aspects.visible;
                };

                scope.onPaste = ($event) => {
                    //solution from: http://stackoverflow.com/questions/27783144/disable-cut-copy-and-paste-function-for-textbox-using-angularjs
                    if (scope.disablePaste) {
                        $event.preventDefault();
                        return false;
                    }
                };

                scope.inputId = inputId++;

                scope.showError = () => {
                    const formHasBeenSubmitted = (parentForm) ? parentForm.submitted : true;
                    const extraModelNotValid = scope.extraModel && !scope.extraModel.aspects.valid;
                    return formHasBeenSubmitted && (!scope.model.aspects.valid || extraModelNotValid);
                };

                scope.getValidationMessages = function () {
                    const messages = [];

                    // Diego Cabero: GALRE-40030: Only displaying the first error message
                    // Diego Cabero: GALRE-40030: Extra model error messages should have more priority
                    if (scope.extraModel && scope.extraModel.aspects.validationMessages.length > 0) {
                        messages.push(scope.extraModel.aspects.validationMessages[0]);
                    } else if (scope.model.aspects.validationMessages.length > 0) {
                        messages.push(scope.model.aspects.validationMessages[0]);
                    }


                    return messages;
                };

                element.on('focusin', () => {
                    scope.focused = true;
                    scope.$applyAsync(); //to fix issue "$apply already in progress" http://stackoverflow.com/questions/18626039/apply-already-in-progress-error
                });
                element.on('focusout', () => {
                    scope.focused = false;
                    scope.$applyAsync(); //to fix issue "$apply already in progress" http://stackoverflow.com/questions/18626039/apply-already-in-progress-error
                });

                scope.clazz = () => _.extend({
                    'gw-error': scope.showError(),
                    'gw-inline-control-group': scope.inline,
                    'gw-control-group': !scope.inline,
                    'gw-control-group-focused': scope.focused,
                }, scope.bslClass);
            },
        };
    };
});



// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/widgets/basicinputs/CtrlGroupDirective.js